
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.267 11.067L3.2 8l3.067-3.067L5.333 4l-4 4 4 4 .934-.933zm3.466 0L12.8 8 9.733 4.933 10.667 4l4 4-4 4-.934-.933z","fill":"currentColor"}})])
          )
        }
      }
    